var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-datetime-picker',{attrs:{"value":new Date(_vm.value),"type":_vm.type,"min-date":_vm.formModel.rules.minDate,"max-date":_vm.formModel.rules.maxDate,"show-toolbar":_vm.showToolbar},on:{"confirm":_vm.__confirm,"cancel":_vm.__cancel,"change":function($event){!_vm.showToolbar && _vm.__change($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }